import React, { useState, Fragment } from 'react';
import './DetailsGridItem.css';
import FieldNames from '../../../defaults/FieldNames.json';
import { Button, Link, Grid } from '@mui/material';
import DetailsDatePicker from './DetailsDatePicker';
import DetailsSelect from './DetailsSelect';
import DetailsCheckbox from './DetailsCheckbox';
import DetailsCurrency from './DetailsCurrency';
import DetailsNumber from './DetailsNumber';
import DetailsText from './DetailsText';
import DetailsTextArea from './DetailsTextArea';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from "react-router-dom";
import DetailsPopover from './DetailsPopover';
import DetailsAutoComplete from './DetailsAutoComplete';
import { getFieldDisplayValue, isFeaturePostFire } from '../../../utils/FeatureHelper';
import fieldsDefinition from '../FieldInfo.json';
import IDService from '../../../services/IDService';
import ErrorService from '../../../services/ErrorService';
import { currencyFormatWithDollar } from '../../../utils/FormatHelper';
import {checkYearIsFourDigits, formatDateForDisplay} from '../../../utils/DateHelper';
import { DatePicker } from '@mui/lab';
import DetailsYearPicker from './DetailsYearPicker';
import { useIFPRSGlobalContext } from '../../../IFPRSGlobalContext';
import { getByLevel } from '../../../utils/CategoryAssociationHelper';
import DetailsInteragency from './DetailsInteragency';
import {
  validateAgencyApprovalDate, validateCompletionDate, validateDepartmentApprovalDate, validateInitiationDate,
  validateLocalApprovalDate, validateRegionalApprovalDate
} from "../../../utils/ValidationHelper";

export default function DetailsGridItem({ field, mode, treatment, activity, onFieldChange, getAllMissingFieldsCount, getAllApprovalFieldsCount, setMode,
  classValue, setClassValue, categoryValue, setCategoryValue, isTreatment, userInfo, userRoleInfo, locationDepartmentValue, setLocationDepartmentValue, locationAgencyValue, setLocationAgencyValue,
  locationRegionValue, setLocationRegionValue, locationUnitValue, setLocationUnitValue, tribeNameValue, setTribeNameValue, isNew, 
  fundingSourceOptions, isCancelled, onFiscalFieldChange, departureIndexOptions, contributedFundingSourceOptions, statusOptions, requiredFields, typeValue,
  setTypeValue, subTypeValue, setSubTypeValue, setIsUnApprovalRequested, setUnApprovalEditorOpen, setUnApprovalDate, setUnApprovalReason, projectValue, setProjectValue,
  unitOfMeasureValue, setUnitOfMeasureValue, programValue, setProgramValue, setCancelEditorOpen, interagencySelected, setInteragencySelected, otherInteragencySelected, 
  setOtherInteragencySelected, itemsToDelete, setItemsToDelete, setIsSaveDisabled }) {
  const fieldIsStatic = activity ? FieldNames.activityStaticFields : FieldNames.staticFields;
  const costFields = FieldNames.costFields;
  const detail = activity ? activity : treatment;
  const currentfieldInfo = fieldsDefinition[field];
  const [isLocallyApproved, setIsLocallyApproved] = useState((detail && detail.attributes && detail.attributes[FieldNames.featureFields.localApprovalDate]) ? true : false);
  const [isRegionalApproved, setIsRegionalApproved] = useState((detail && detail.attributes && detail.attributes[FieldNames.featureFields.regionalApprovalDate]) ? true : false);
  const [isAgencyApproved, setIsAgencyApproved] = useState((detail && detail.attributes && detail.attributes[FieldNames.featureFields.agencyApprovalDate]) ? true : false);
  const [isDepartmentApproved, setIsDepartmentApproved] = useState((detail && detail.attributes && detail.attributes[FieldNames.featureFields.departmentApprovalDate]) ? true : false);
  const navigate = useNavigate();

  const isLApproved = (val) => {
    if(val !== undefined && val !== null && val !== ''){
      setIsLocallyApproved(val);
    } else {
      setIsLocallyApproved(false)
    }
  }

  const isRApproved = (val) => {
    if(val !== undefined && val !== null && val !== ''){
      setIsRegionalApproved(val);
    } else {
      setIsRegionalApproved(false)
    }
  }

  const isAApproved = (val) => {
    if(val !== undefined && val !== null && val !== ''){
      setIsAgencyApproved(val);
    } else {
      setIsAgencyApproved(false)
    }
  }

  const isDApproved = (val) => {
    if(val !== undefined && val !== null && val !== ''){
      setIsDepartmentApproved(val);
    } else {
      setIsDepartmentApproved(false)
    }
  }

  const percentageFormat = (num) => {
    const trimmedNum = num.trim('\'');
    return trimmedNum + '%';
  }

  const getReadOnlyString = (fieldName) => {
    const isPostFire = isFeaturePostFire(detail?.attributes);
    if((detail && detail.attributes && detail.attributes[fieldName]) || (detail?.attributes && fieldName === FieldNames.featureFields.interagencySupport )) {
      let finalValue = detail.attributes[fieldName];
      if (fieldName === FieldNames.featureFields.calculatedArea) {
      const unit = detail?.attributes[FieldNames.featureFields.areaUnit] ? detail.attributes[FieldNames.featureFields.areaUnit] : '';
      finalValue = `${detail?.attributes[FieldNames.featureFields.calculatedArea]?.toFixed(1)} ${unit}`;
    } else if (fieldName && (costFields && costFields.includes(fieldName))) {
        finalValue = currencyFormatWithDollar(detail.attributes[fieldName])
      } else if (fieldName === FieldNames.featureFields.isFunded || fieldName === FieldNames.featureFields.isRTRL  || (fieldName === FieldNames.featureFields.isInteragency && !isPostFire)) {
        if (detail.attributes[fieldName] === FieldNames.yesNo.yes) {
          finalValue = FieldNames.yesNo.yes
        } else {
          finalValue = FieldNames.yesNo.no
        }
      } else if(fieldName === FieldNames.featureFields.measureAmount || fieldName === FieldNames.featureFields.unitOfMeasure){
        if(isPostFire){
          finalValue = `${detail.attributes[fieldName]}`;
        } else {
          finalValue = "";
        }
      } else if(fieldName === FieldNames.featureFields.id){
        finalValue = detail.attributes[FieldNames.featureFields.id];
      } else if(fieldName === FieldNames.featureFields.vegDeparturePercentageManual){
        if(parseInt(detail.attributes[fieldName]) > 100 || detail.attributes[fieldName] < 0){
          finalValue = "";
        } else {
          finalValue = `${detail.attributes[fieldName]}`;
        }
      } else if (fieldName === FieldNames.featureFields.isVegetationManual) {
        finalValue = detail.attributes[fieldName] === FieldNames.yesNo.yes ? FieldNames.yesNo.yes : FieldNames.yesNo.no;
      } else if (fieldName === FieldNames.featureFields.initiationDate ||
        fieldName === FieldNames.featureFields.completionDate ||
        fieldName === FieldNames.featureFields.localApprovalDate ||
        fieldName === FieldNames.featureFields.agencyApprovalDate ||
        fieldName === FieldNames.featureFields.departmentApprovalDate ||
        fieldName === FieldNames.featureFields.regionalApprovalDate ||
        fieldName === FieldNames.featureFields.cancelledDate ||
        fieldName === FieldNames.featureFields.createdOnDate ||
        fieldName === FieldNames.featureFields.lastModifiedDate || 
        fieldName === FieldNames.featureFields.unApprovalDate ||
        fieldName === FieldNames.featureFields.fireDiscoveryDate ||
        fieldName === FieldNames.featureFields.containmentDate) {
        finalValue = formatDateForDisplay(detail.attributes[fieldName]);
        //dateDisplayFormat(detail.attributes[fieldName])
      } else if(fieldName === FieldNames.featureFields.obligationFiscalYear || fieldName === FieldNames.featureFields.ignitionFiscalYear) {
        finalValue = detail.attributes[field];
      } else if(fieldName === FieldNames.featureFields.fundingSubUnit) {
        if(detail.attributes[FieldNames.featureFields.fundingAgency]){
          finalValue = getFieldDisplayValue(detail.attributes[fieldName], fieldName, FieldNames.featureFields);
        } else {
          if(detail.attributes[FieldNames.featureFields.fundingAgency] === FieldNames.agencies.blm){
            finalValue = getFieldDisplayValue(detail.attributes[fieldName], fieldName, FieldNames.featureFields);
          } else {
            finalValue = '';
          }
        }
      } else if(fieldName === FieldNames.featureFields.fundingTribe) {
        if(detail.attributes[FieldNames.featureFields.fundingAgency]){
          finalValue = getFieldDisplayValue(detail.attributes[fieldName], fieldName, FieldNames.featureFields);
        } else {
          if(detail.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.bia)){
            finalValue = getFieldDisplayValue(detail.attributes[fieldName], fieldName, FieldNames.featureFields);
          } else {
            finalValue = '';
          }
        }
      } else if(fieldName === FieldNames.featureFields.estimatedSuccessProbability){
        finalValue = detail.attributes[field].replace(/'/g,'');
        finalValue = percentageFormat(finalValue)
        return finalValue;
      } else if(fieldName === FieldNames.featureFields.subType) {
        const subTypePossibleValues = getByLevel(detail?.attributes, FieldNames.categoryAssociationFields.subTypes)
        if(subTypePossibleValues?.length > 0){
          finalValue = `${detail.attributes[fieldName]}`;
        } else {
          finalValue = ``;
        }
      } else if(fieldName === FieldNames.featureFields.fundingDepartment || fieldName === FieldNames.featureFields.fundingAgency ||
        fieldName === FieldNames.featureFields.fundingRegion || fieldName === FieldNames.featureFields.fundingUnit ||
        fieldName === FieldNames.featureFields.fundingSubUnit || fieldName === FieldNames.featureFields.fundingUnitType ||
        fieldName === FieldNames.featureFields.fundingSource || fieldName === FieldNames.featureFields.fundingSourceProgram ||
        fieldName === FieldNames.featureFields.fundingSourceCategory || fieldName === FieldNames.featureFields.fundingSourceSubCategory){
        finalValue = getFieldDisplayValue(detail.attributes[fieldName], fieldName, FieldNames.featureFields);
      } else if(fieldName === FieldNames.featureFields.interagencySupport) {
        if(isPostFire || (!isPostFire && detail?.attributes[FieldNames.featureFields.isInteragency] !== FieldNames.yesNo.yes)) {
          finalValue = '';
        } else {
          if(detail.attributes[FieldNames.featureFields.interagencyName]){
            finalValue = detail.attributes[FieldNames.featureFields.interagencyName]?.split('|')?.sort((a, b) => (a > b) ? 1 : -1)?.join(', ');
          } else {
            finalValue = '--'
          }
        }
      } else if (currentfieldInfo?.domain && currentfieldInfo?.domain.codedValues) {
        const codes = currentfieldInfo?.domain.codedValues;
        codes.forEach((element) => {
          if (detail.attributes[fieldName] === element.code) {
            finalValue = element.name;
          }
        })
      } else if (fieldName === FieldNames.featureFields.parentID) {
        finalValue = <Link onClick={() => parentRedirect(detail.attributes[fieldName], FieldNames.modes.read, FieldNames.featureFields)}><span className='pointer'>{detail.attributes[fieldName]}</span></Link>
      } else if(fieldName === FieldNames.featureFields.wbsID && detail.attributes[fieldName] === "XXXXXXXXXXXX") {
        finalValue = "--";
      }
      else if(fieldName === FieldNames.featureFields.wbsID && detail.attributes[FieldNames.featureFields.fundingAgency] && detail.attributes[fieldName]
        && detail.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.blm) 
        && detail.attributes[FieldNames.featureFields.wbsID].length === 4
      ) {
        finalValue = "LF.HF." + detail.attributes[fieldName] + "0000";
      } else {
        finalValue = detail.attributes[fieldName];
      }
      return finalValue;
    } else if(fieldName === FieldNames.featureFields.unApprovalButton) {
      return '';
    } else if(fieldName === FieldNames.featureFields.measureAmount || fieldName === FieldNames.featureFields.unitOfMeasure){
      if(isPostFire){
        return '--'
      } else {
        return;
      }
    } else if(fieldName === FieldNames.featureFields.isInteragency){
      if(!isPostFire){
        return '--'
      } else {
        return;
      }
    } else if(fieldName === FieldNames.featureFields.interagencySupport){
      if(!isPostFire && detail?.attributes[FieldNames.featureFields.isInteragency] === FieldNames.yesNo.yes) {
        return '--'
      } else {
        return;
      }
    } else if (fieldName === FieldNames.featureFields.calculatedArea) {
      const unit = detail?.attributes[FieldNames.featureFields.areaUnit] ? detail.attributes[FieldNames.featureFields.areaUnit] : '';
      return `${detail?.attributes[FieldNames.featureFields.calculatedArea]?.toFixed(1)} ${unit}`;
    }
    else {
      if(fieldName === FieldNames.featureFields.fundingSubUnit && (!detail?.attributes[FieldNames.featureFields.fundingAgency] || !detail?.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.blm))){
        return '';
      } else if(fieldName === FieldNames.featureFields.fundingTribe && ((!detail?.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.bia)) || !detail?.attributes[FieldNames.featureFields.fundingAgency])){
        return '';
      } else {
        return '--';
      }
      
    }
  }

  const parentRedirect = (id, modeState, allFields) => {
    const isPostFire = isFeaturePostFire(detail);
    const entityStringValue = isPostFire ? "pf" : "f";
    IDService.getActionObjectID(id).then(objectId => {
      if((detail?.attributes[allFields.isParentTreatment] && 
        detail?.attributes[allFields.isParentTreatment] === 'Yes') || isTreatment){
        navigate(`/${entityStringValue}/treatments/${objectId}`, {isActual: false});
      } else {
        navigate(`/${entityStringValue}/activities/${objectId}`, {isActual: false})
      }
      setMode(modeState);
    }).catch(error => {
      ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
    })
  }

  const isEditableAfterApproval = (field, isNew) => {
    let isEditable = false;
    if(detail && detail.attributes){
      if(isNew && (!isDepartmentApproved && !isAgencyApproved && !isRegionalApproved && !isLocallyApproved && !detail.attributes[FieldNames.featureFields.localApprovalDate] && !detail.attributes[FieldNames.featureFields.regionalApprovalDate] && 
        !detail.attributes[FieldNames.featureFields.departmentApprovalDate] && !detail.attributes[FieldNames.featureFields.agencyApprovalDate])){
        isEditable = true;
      } else {
        //Lock down once approved
        if((detail.attributes[FieldNames.featureFields.modifiedBy] === FieldNames.modifiedBy.nfpors && !detail.attributes[field]) ||
         (!isDepartmentApproved && !isAgencyApproved && !isRegionalApproved && !isLocallyApproved &&!detail.attributes[FieldNames.featureFields.localApprovalDate] && !detail.attributes[FieldNames.featureFields.regionalApprovalDate] && 
          !detail.attributes[FieldNames.featureFields.departmentApprovalDate] && !detail.attributes[FieldNames.featureFields.agencyApprovalDate])){
          if(
            // Location Fields
            field === FieldNames.featureFields.department || field === FieldNames.featureFields.agency || field === FieldNames.featureFields.region 
            || field === FieldNames.featureFields.unit || field === FieldNames.featureFields.tribeName 
            // Funding Fields
            || field === FieldNames.featureFields.fundingDepartment || field === FieldNames.featureFields.fundingAgency 
            || field === FieldNames.featureFields.fundingRegion || field === FieldNames.featureFields.fundingUnit || field === FieldNames.featureFields.fundingTribe)
          {
            // Fields in this conditional are editable as long as there are no approval dates set
            isEditable = true;
          } else {
            //Only allow editing if the field hasn't been set yet
            if(!detail.attributes[field]){
              isEditable = true;
            }
          }
        }
      }
    }
    return isEditable;
  }

  const isFieldLockedDown = (field, detail) => {
    if(!field || !detail?.attributes)
    {
      // Some sort of error, so don't lock down field by accident
      return false;
    }
    return (
      (field === FieldNames.featureFields.department && detail?.attributes[FieldNames.featureFields.locationDepartmentLocked] === FieldNames.yesNo.yes) 
      || (field === FieldNames.featureFields.agency && detail?.attributes[FieldNames.featureFields.locationAgencyLocked] === FieldNames.yesNo.yes) 
      || (field === FieldNames.featureFields.region && detail?.attributes[FieldNames.featureFields.locationRegionLocked] === FieldNames.yesNo.yes) 
      || (field === FieldNames.featureFields.unit && detail?.attributes[FieldNames.featureFields.locationUnitLocked] === FieldNames.yesNo.yes) 
    )
  }

  const addUnApprovalDate = () => {
    setIsUnApprovalRequested(true);
    setUnApprovalEditorOpen(true);
    setUnApprovalDate(new Date());
  }

  const clearUnApprovalDate = () => {
    setIsUnApprovalRequested(false);
    setUnApprovalDate(null);
    setUnApprovalReason("");
    onFieldChange(FieldNames.featureFields.unApprovalDate, null);
  }

  const getEditControlForField = (fieldInfo) => {
    let isRequiredField = false;
    const isPostFire = isFeaturePostFire(detail.attributes)
    if(requiredFields && requiredFields.length){
      isRequiredField = requiredFields.includes(field);
    }
    if(detail && detail.attributes){
      if(fieldInfo.name === FieldNames.featureFields.isInteragency && isPostFire){
        return ('');
      }
      if (fieldInfo) {
        if(fieldInfo === FieldNames.featureFields.unApprovalButton){
          return ('')
        } else if(fieldInfo.name === FieldNames.featureFields.interagencySupport && !isPostFire) {
          if(detail && detail.attributes && detail.attributes[FieldNames.featureFields.isInteragency] === FieldNames.yesNo.yes) {
            return (
              <DetailsInteragency
                detail={detail}
                fieldInfo={fieldInfo}
                field={field}
                onFieldChange={onFieldChange}
                allFields={FieldNames.featureFields}
                interagencySelected={interagencySelected}
                setInteragencySelected={setInteragencySelected}
                otherInteragencySelected={otherInteragencySelected}
                setOtherInteragencySelected={setOtherInteragencySelected}
                itemsToDelete={itemsToDelete}
                setItemsToDelete={setItemsToDelete}
                userInfo={userInfo}
              />
            )
          } else {
            return ('')
          }
        } else {
          if (costFields?.includes(fieldInfo.name) && detail && detail.attributes) {
            return (
              <DetailsCurrency
                detail={detail}
                currencyValue={detail.attributes[field]}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={isRequiredField}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                costFields={costFields}
              />
            )
          } else if (fieldInfo.name === FieldNames.legacyIDFields.treatmentID || fieldInfo.name === FieldNames.legacyIDFields.activityID) {
            if(detail && detail.attributes){
              if (!detail.attributes[fieldInfo.name]) {
                detail.attributes[fieldInfo.name] = uuidv4();
              }
            }
            return (
              <DetailsText
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={isRequiredField}
                fieldIsStatic={fieldIsStatic.includes(field)}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
              />
            )
          } else if (fieldInfo.name === FieldNames.featureFields.isFunded) {
            if(detail){
              return (
                <DetailsCheckbox
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  allFields={FieldNames.featureFields}
                />
              )
            } else {
              return ('')
            }
          } else if(fieldInfo.name === FieldNames.featureFields.vegDeparturePercentageManual) {
            return (
              <DetailsNumber
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={isRequiredField}
                fieldIsStatic={fieldIsStatic.includes(field)}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                max={100}
                min={0}
              />
            )
          } else if(fieldInfo.name === FieldNames.featureFields.isVegetationManual) {
            return (
              <DetailsCheckbox
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                allFields={FieldNames.featureFields}
              />
            )
          } else if (fieldInfo.name === FieldNames.featureFields.notes || fieldInfo.name === FieldNames.featureFields.contributedNotes) {
            return (
              <DetailsTextArea
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={isRequiredField}
                fieldIsStatic={fieldIsStatic.includes(field)}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                isActuals={false}
              />
            )
          } else if (fieldInfo.name === FieldNames.featureFields.fireDiscoveryDate || fieldInfo.name === FieldNames.featureFields.containmentDate) {
            return (
              <DetailsDatePicker
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                isLocallyApproved={isLocallyApproved}
                setIsLocallyApproved={isLApproved}
                isRegionalApproved={isRegionalApproved}
                setIsRegionalApproved={isRApproved}
                isAgencyApproved={isAgencyApproved}
                setIsAgencyApproved={isAApproved}
                isDepartmentApproved={isDepartmentApproved}
                setIsDepartmentApproved={isDApproved}
                isRequired={isRequiredField}
                getAllMissingFieldsCount={getAllMissingFieldsCount}
                allFields={FieldNames.featureFields}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                isPast={false}
                userInfo={userInfo}
                userRoleInfo={userRoleInfo}
                isCancelled={isCancelled}
                isWithinFiscalYear={true}
                onFiscalFieldChange={onFiscalFieldChange}
                isActuals={false}
                departmentValue={detail?.attributes[FieldNames.featureFields.fundingDepartment]}
                agencyValue={detail?.attributes[FieldNames.featureFields.fundingAgency]}
                regionValue={detail?.attributes[FieldNames.featureFields.fundingRegion]}
                unitValue={detail?.attributes[FieldNames.featureFields.fundingUnit]}
                fundingTribeValue={detail?.attributes[FieldNames.featureFields.fundingTribe]}
                isTreatment={isTreatment}
              />
            )
            //dateDisplayFormat(detail.attributes[fieldName])
          } else if (fieldInfo.name === FieldNames.featureFields.statusReason) {
            let tempReqFields = requiredFields;
            if(!getAllApprovalFieldsCount()){
              if(treatment && treatment.attributes && requiredFields && requiredFields.length){
                if(treatment.attributes[FieldNames.featureFields.status] !== FieldNames.statuses.cancelled){
                  tempReqFields = requiredFields.filter(field => field !== FieldNames.featureFields.statusReason);
                }
              } else if(activity && requiredFields && requiredFields.length){
                if(activity.attributes[FieldNames.featureFields.status] !== FieldNames.statuses.cancelled){
                  tempReqFields = requiredFields.filter(field => field !== FieldNames.featureFields.statusReason);
                }
              }
            }
            let isTempReqFields = false;
            if(tempReqFields && tempReqFields.length){
              isTempReqFields = tempReqFields.includes(field);
            }
            return (
              <DetailsTextArea
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={isTempReqFields}
                fieldIsStatic={false}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                isActuals={false}
              />
            )
          } else if (fieldInfo.name === FieldNames.featureFields.unApprovalReason) {
            return (
              <DetailsTextArea
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={detail && detail.attributes && detail.attributes[FieldNames.featureFields.unApprovalDate] ? true : false}
                fieldIsStatic={true}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                isActuals={false}
              />
            )
          } else if (fieldInfo.name === FieldNames.featureFields.initiationDate ||
            fieldInfo.name === FieldNames.featureFields.completionDate ||
            fieldInfo.name === FieldNames.featureFields.createdOnDate ||
            fieldInfo.name === FieldNames.featureFields.lastModifiedDate ||
            fieldInfo.name === FieldNames.featureFields.unApprovalDate) {
            const validators = {
              [FieldNames.featureFields.initiationDate ]: [
                checkYearIsFourDigits,
                validateInitiationDate
              ],
              [FieldNames.featureFields.completionDate]: [
                checkYearIsFourDigits,
                validateCompletionDate
              ]
            }
            return (
              <DetailsDatePicker
                detail={detail}
                field={field}
                validators={validators[fieldInfo.name]}
                onFieldChange={onFieldChange}
                isLocallyApproved={isLocallyApproved}
                setIsLocallyApproved={isLApproved}
                isRegionalApproved={isRegionalApproved}
                setIsRegionalApproved={isRApproved}
                isAgencyApproved={isAgencyApproved}
                setIsAgencyApproved={isAApproved}
                isDepartmentApproved={isDepartmentApproved}
                setIsDepartmentApproved={isDApproved}
                isRequired={isRequiredField}
                getAllMissingFieldsCount={getAllMissingFieldsCount}
                allFields={FieldNames.featureFields}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                isPast={false}
                userInfo={userInfo}
                userRoleInfo={userRoleInfo}
                isCancelled={isCancelled}
                isWithinFiscalYear={true}
                onFiscalFieldChange={onFiscalFieldChange}
                isActuals={false}
                departmentValue={detail?.attributes[FieldNames.featureFields.fundingDepartment]}
                agencyValue={detail?.attributes[FieldNames.featureFields.fundingAgency]}
                regionValue={detail?.attributes[FieldNames.featureFields.fundingRegion]}
                unitValue={detail?.attributes[FieldNames.featureFields.fundingUnit]}
                fundingTribeValue={detail?.attributes[FieldNames.featureFields.fundingTribe]}
                isTreatment={isTreatment}
              />
            )
          } else if(fieldInfo.name === FieldNames.featureFields.obligationFiscalYear){
            return (
              <DetailsYearPicker
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={isRequiredField}
                allFields={FieldNames.featureFields}
                isActuals={false}
              />
            )
          } else if (fieldInfo.name === FieldNames.featureFields.localApprovalDate ||
            fieldInfo.name === FieldNames.featureFields.agencyApprovalDate ||
            fieldInfo.name === FieldNames.featureFields.departmentApprovalDate ||
            fieldInfo.name === FieldNames.featureFields.regionalApprovalDate) {

            const validators = {
              [FieldNames.featureFields.localApprovalDate]: [
                  checkYearIsFourDigits,
                  validateLocalApprovalDate
              ],
              [FieldNames.featureFields.agencyApprovalDate]: [
                  checkYearIsFourDigits,
                  validateAgencyApprovalDate
              ],
              [FieldNames.featureFields.departmentApprovalDate]: [
                  checkYearIsFourDigits,
                validateDepartmentApprovalDate
              ],
              [FieldNames.featureFields.regionalApprovalDate]: [
                  checkYearIsFourDigits,
                  validateRegionalApprovalDate
              ]
            }

            return (
              <DetailsDatePicker
                detail={detail}
                field={field}
                validators={validators[fieldInfo.name]}
                onFieldChange={onFieldChange}
                isLocallyApproved={isLocallyApproved}
                setIsLocallyApproved={isLApproved}
                isRegionalApproved={isRegionalApproved}
                setIsRegionalApproved={isRApproved}
                isAgencyApproved={isAgencyApproved}
                setIsAgencyApproved={isAApproved}
                isDepartmentApproved={isDepartmentApproved}
                setIsDepartmentApproved={isDApproved}
                isRequired={isRequiredField}
                getAllMissingFieldsCount={getAllMissingFieldsCount}
                allFields={FieldNames.featureFields}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                isPast={false}
                userInfo={userInfo}
                userRoleInfo={userRoleInfo}
                isCancelled={null}
                isWithinFiscalYear={true}
                onFiscalFieldChange={onFiscalFieldChange}
                isActuals={false}
                departmentValue={detail?.attributes[FieldNames.featureFields.fundingDepartment]}
                agencyValue={detail?.attributes[FieldNames.featureFields.fundingAgency]}
                regionValue={detail?.attributes[FieldNames.featureFields.fundingRegion]}
                unitValue={detail?.attributes[FieldNames.featureFields.fundingUnit]}
                fundingTribeValue={detail?.attributes[FieldNames.featureFields.fundingTribe]}
                isTreatment={isTreatment}
              />
            )
          } else if (fieldInfo.name === FieldNames.featureFields.durability) {
            return (
              <DetailsNumber
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={isRequiredField}
                fieldIsStatic={fieldIsStatic.includes(field)}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
              />
            )
          } else if (fieldInfo.name === FieldNames.featureFields.parentID) {
            if (detail && detail.attributes && detail.attributes[fieldInfo.name]) {
              return (
                <Link onClick={() => parentRedirect(detail.attributes[fieldInfo.name], FieldNames.modes.read, FieldNames.featureFields)}><span className='pointer'>{detail.attributes[fieldInfo.name]}</span></Link>
              )
            } else {
              return (
                <span>--</span>
              )
            }
          } else if(fieldInfo.name === FieldNames.featureFields.tribeName){
            if(detail && detail.attributes){
              const isEditable = isEditableAfterApproval(field, isNew);
              if(isEditable){
                return (
                  <DetailsAutoComplete
                    userInfo={userInfo} 
                    field={field}
                    parentValue={null}
                    selectionValue={tribeNameValue}
                    setSelectionValue={setTribeNameValue}
                    userRoleInfo={userRoleInfo}
                    onFieldChange={onFieldChange}
                    detail={detail}
                    isRequired={isRequiredField}
                  />
                )
              } else {
                return (
                  <DetailsText
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={isRequiredField}
                    fieldIsStatic={true}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    selectionValue={tribeNameValue}
                  />
                )
              }
            }
          } else if(fieldInfo.name === FieldNames.featureFields.agency){
            if(detail && detail.attributes){
              const isEditable = isEditableAfterApproval(field, isNew) && !isFieldLockedDown(field, detail);
              if(isEditable){
                return (
                  <DetailsAutoComplete
                    userInfo={userInfo}
                    field={field}
                    parentValue={null}
                    selectionValue={locationAgencyValue}
                    setSelectionValue={setLocationAgencyValue}
                    userRoleInfo={userRoleInfo}
                    onFieldChange={onFieldChange}
                    detail={detail}
                    isRequired={isRequiredField}
                  />
                )
              } else {
                return (
                  <DetailsText
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={isRequiredField}
                    fieldIsStatic={true}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    selectionValue={tribeNameValue}
                  />
                )
              }
            }
          } else if(fieldInfo.name === FieldNames.featureFields.region){
            if(detail && detail.attributes){
              const isEditable = isEditableAfterApproval(field, isNew) && !isFieldLockedDown(field, detail);
              if(isEditable){
                return (
                  <DetailsAutoComplete 
                    userInfo={userInfo} 
                    field={field}
                    parentValue={null}
                    selectionValue={locationRegionValue}
                    setSelectionValue={setLocationRegionValue}
                    userRoleInfo={userRoleInfo}
                    onFieldChange={onFieldChange}
                    detail={detail}
                    isRequired={isRequiredField}
                  />
                )
              } else {
                return (
                  <DetailsText
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={isRequiredField}
                    fieldIsStatic={true}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    selectionValue={tribeNameValue}
                  />
                )
              }
            }
          } else if(fieldInfo.name === FieldNames.featureFields.unit){
            if(detail && detail.attributes){
              const isEditable = isEditableAfterApproval(field, isNew) && !isFieldLockedDown(field, detail);
              if(isEditable){
                return (
                  <DetailsAutoComplete 
                    userInfo={userInfo} 
                    field={field}
                    parentValue={null}
                    selectionValue={locationUnitValue}
                    setSelectionValue={setLocationUnitValue}
                    userRoleInfo={userRoleInfo}
                    onFieldChange={onFieldChange}
                    detail={detail}
                    isRequired={isRequiredField}
                  />
                )
              } else {
                return (
                  <DetailsText
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={isRequiredField}
                    fieldIsStatic={true}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    selectionValue={tribeNameValue}
                  />
                )
              }
            }
          } else if(fieldInfo.name === FieldNames.featureFields.fundingSource || fieldInfo.name === FieldNames.featureFields.fundingUnitType || 
            fieldInfo.name === FieldNames.featureFields.fundingUnit || fieldInfo.name === FieldNames.featureFields.fundingRegion || 
            fieldInfo.name === FieldNames.featureFields.fundingAgency || fieldInfo.name === FieldNames.featureFields.fundingDepartment || 
            fieldInfo.name === FieldNames.featureFields.fundingSourceProgram || fieldInfo.name === FieldNames.featureFields.fundingSourceCategory ||
            fieldInfo.name === FieldNames.featureFields.fundingSourceSubCategory){   
            if(detail && detail.attributes){
              const tempVal = getFieldDisplayValue(detail.attributes[field], fieldInfo.name, FieldNames.featureFields);
              return (
                <DetailsText
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isRequiredField}
                  fieldIsStatic={false}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  selectionValue={tempVal}
                />
              )
            }
          } else if(fieldInfo.name === FieldNames.featureFields.fundingSubUnit){
            if(detail.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.blm) && detail && detail.attributes){
              const tempVal = getFieldDisplayValue(detail.attributes[field], fieldInfo.name, FieldNames.featureFields);
              return (
                <DetailsText
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isRequiredField}
                  fieldIsStatic={false}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  selectionValue={tempVal}
                />
              )
            } else {
              return <span></span>
            }
          } else if(fieldInfo.name === FieldNames.featureFields.fundingTribe){
            if(detail.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.bia) && detail && detail.attributes){
              const tempVal = getFieldDisplayValue(detail.attributes[field], fieldInfo.name, FieldNames.featureFields);
              return (
                <DetailsText
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isRequiredField}
                  fieldIsStatic={false}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  selectionValue={tempVal}
                />
              )
            } else {
              return <span></span>
            }
          } else if (fieldInfo.name === FieldNames.featureFields.department) {
            if(detail && detail.attributes){
              return (
                <DetailsSelect
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  fieldInfo={fieldInfo}
                  isRequired={isRequiredField}
                  allFields={FieldNames.featureFields}
                  fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, detail)}
                  classValue={classValue}
                  setClassValue={setClassValue}
                  categoryValue={categoryValue}
                  setCategoryValue={setCategoryValue}
                  unitOfMeasureValue={unitOfMeasureValue}
                  setUnitOfMeasureValue={setUnitOfMeasureValue}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  fundingSourceOptions={fundingSourceOptions}
                  departureOptions={departureIndexOptions}
                  statusOptions={statusOptions}
                  isActuals={false}
                  typeValue={typeValue}
                  setTypeValue={setTypeValue}
                  subTypeValue={subTypeValue}
                  setSubTypeValue={setSubTypeValue}
                  agencyValue={detail?.attributes?.[FieldNames.featureFields.fundingAgency]}
                  locationDepartmentValue={locationDepartmentValue}
                  setLocationDepartmentValue={setLocationDepartmentValue}
                  programValue={programValue}
                  setProgramValue={setProgramValue}
                />
              )
            }
          } else if(fieldInfo.name === FieldNames.featureFields.contributedFundingSource) { 
            const fundOptions = contributedFundingSourceOptions;
            return (
              <DetailsSelect
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                fieldInfo={fieldInfo}
                isRequired={isRequiredField}
                allFields={FieldNames.featureFields}
                fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, detail)}
                classValue={classValue}
                setClassValue={setClassValue}
                categoryValue={categoryValue}
                setCategoryValue={setCategoryValue}
                unitOfMeasureValue={unitOfMeasureValue}
                setUnitOfMeasureValue={setUnitOfMeasureValue}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                fundingSourceOptions={fundingSourceOptions}
                departureOptions={departureIndexOptions}
                statusOptions={statusOptions}
                isActuals={false}
                typeValue={typeValue}
                setTypeValue={setTypeValue}
                subTypeValue={subTypeValue}
                setSubTypeValue={setSubTypeValue}
                agencyValue={detail?.attributes?.[FieldNames.featureFields.fundingAgency]}
                locationDepartmentValue={locationDepartmentValue}
                setLocationDepartmentValue={setLocationDepartmentValue}
                programValue={programValue}
                setProgramValue={setProgramValue}
              />
            )
          } else if(fieldInfo.name === FieldNames.featureFields.type || fieldInfo.name === FieldNames.featureFields.category || 
            fieldInfo.name === FieldNames.featureFields.class || fieldInfo.name === FieldNames.featureFields.unitOfMeasure ||
            fieldInfo.name === FieldNames.featureFields.program) {
            let onlyAgencyRole = detail?.attributes[FieldNames.featureFields.fundingAgency];
            if(!onlyAgencyRole && userRoleInfo && userRoleInfo.length === 1){
              onlyAgencyRole = userRoleInfo[0][FieldNames.userRoles.agency];
            }
            const isPostFire = isFeaturePostFire(detail.attributes)
            if(detail && detail.attributes){
              if(fieldInfo.name !== FieldNames.featureFields.unitOfMeasure || (isPostFire && fieldInfo.name === FieldNames.featureFields.unitOfMeasure)){
                return (
                  <DetailsSelect
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    fieldInfo={fieldInfo}
                    isRequired={isRequiredField}
                    allFields={FieldNames.featureFields}
                    fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, detail)}
                    classValue={classValue}
                    setClassValue={setClassValue}
                    categoryValue={categoryValue}
                    setCategoryValue={setCategoryValue}
                    unitOfMeasureValue={unitOfMeasureValue}
                    setUnitOfMeasureValue={setUnitOfMeasureValue}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    fundingSourceOptions={fundingSourceOptions}
                    departureOptions={departureIndexOptions}
                    statusOptions={statusOptions}
                    isActuals={false}
                    typeValue={typeValue}
                    setTypeValue={setTypeValue}
                    subTypeValue={subTypeValue}
                    setSubTypeValue={setSubTypeValue}
                    agencyValue={detail && detail.attributes && detail.attributes[FieldNames.featureFields.fundingAgency] ? detail.attributes[FieldNames.featureFields.fundingAgency] : onlyAgencyRole}
                    locationDepartmentValue={locationDepartmentValue}
                    setLocationDepartmentValue={setLocationDepartmentValue}
                    programValue={programValue}
                    setProgramValue={setProgramValue}
                  />
                )
              } else {
                return ('')
              }
            }
          } else if(fieldInfo.name === FieldNames.featureFields.subType) {
            let onlyAgencyRole = detail?.attributes[FieldNames.featureFields.fundingAgency];
            if(!onlyAgencyRole && userRoleInfo && userRoleInfo.length === 1){
              onlyAgencyRole = userRoleInfo[0][FieldNames.userRoles.agency];
            }
            const subTypePossibleValues = getByLevel(detail?.attributes, FieldNames.categoryAssociationFields.subTypes)
            if(detail && detail.attributes && subTypePossibleValues?.length > 0){
              return (
                <DetailsSelect
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  fieldInfo={fieldInfo}
                  isRequired={isRequiredField}
                  allFields={FieldNames.featureFields}
                  fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, detail)}
                  classValue={classValue}
                  setClassValue={setClassValue}
                  categoryValue={categoryValue}
                  setCategoryValue={setCategoryValue}
                  unitOfMeasureValue={unitOfMeasureValue}
                  setUnitOfMeasureValue={setUnitOfMeasureValue}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  fundingSourceOptions={fundingSourceOptions}
                  departureOptions={departureIndexOptions}
                  statusOptions={statusOptions}
                  isActuals={false}
                  typeValue={typeValue}
                  setTypeValue={setTypeValue}
                  subTypeValue={subTypeValue}
                  setSubTypeValue={setSubTypeValue}
                  agencyValue={detail && detail.attributes && detail.attributes[FieldNames.featureFields.fundingAgency] ? detail.attributes[FieldNames.featureFields.fundingAgency] : onlyAgencyRole}
                  locationDepartmentValue={locationDepartmentValue}
                  setLocationDepartmentValue={setLocationDepartmentValue}
                  programValue={programValue}
                  setProgramValue={setProgramValue}
                />
              )
            } else {
              return <span></span>
            }
          } else if(fieldInfo.name === FieldNames.featureFields.status) {
            return (
              <DetailsSelect
                detail={detail}
                field={field}
                onFieldChange={onFieldChange}
                fieldInfo={fieldInfo}
                isRequired={isRequiredField}
                allFields={FieldNames.featureFields}
                fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, detail)}
                classValue={classValue}
                setClassValue={setClassValue}
                categoryValue={categoryValue}
                setCategoryValue={setCategoryValue}
                unitOfMeasureValue={unitOfMeasureValue}
                setUnitOfMeasureValue={setUnitOfMeasureValue}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                fundingSourceOptions={fundingSourceOptions}
                departureOptions={departureIndexOptions}
                statusOptions={statusOptions}
                isActuals={false}
                typeValue={typeValue}
                setTypeValue={setTypeValue}
                subTypeValue={subTypeValue}
                setSubTypeValue={setSubTypeValue}
                agencyValue={detail?.attributes?.[FieldNames.featureFields.fundingAgency]}
                locationDepartmentValue={locationDepartmentValue}
                setLocationDepartmentValue={setLocationDepartmentValue}
                programValue={programValue}
                setProgramValue={setProgramValue}
              />
            )
          } else if(fieldInfo.name === FieldNames.featureFields.projectName) {
            return (
              <DetailsAutoComplete
                userInfo={userInfo} 
                field={field}
                parentValue={null}
                selectionValue={projectValue}
                setSelectionValue={setProjectValue}
                userRoleInfo={userRoleInfo}
                onFieldChange={onFieldChange}
                detail={detail}
                isRequired={isRequiredField}
              />
            )
          } else {
            if (costFields?.includes(fieldInfo.name) && detail && detail?.attributes) {
              return (
                <DetailsCurrency
                  detail={detail}
                  currencyValue={detail.attributes[field]}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isRequiredField}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  costFields={costFields}
                />
              )
            } else if (fieldInfo.name === FieldNames.legacyIDFields.treatmentID || fieldInfo.name === FieldNames.legacyIDFields.activityID) {
              if(detail && detail?.attributes){
                if (!detail.attributes[fieldInfo.name]) {
                  detail.attributes[fieldInfo.name] = uuidv4();
                }
              }
              return (
                <DetailsText
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isRequiredField}
                  fieldIsStatic={fieldIsStatic.includes(field)}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                />
              )
            } else if (fieldInfo.name === FieldNames.featureFields.isFunded) {
              if(detail){
                return (
                  <DetailsCheckbox
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    allFields={FieldNames.featureFields}
                  />
                )
              } else {
                return ('')
              }
            } else if(fieldInfo.name === FieldNames.featureFields.vegDeparturePercentageManual) {
              return (
                <DetailsNumber
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isRequiredField}
                  fieldIsStatic={fieldIsStatic.includes(field)}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  max={100}
                  min={0}
                />
              )
            } else if(fieldInfo.name === FieldNames.featureFields.measureAmount){
              const isPostFire = isFeaturePostFire(detail.attributes)
              if(isPostFire){
                return (
                  <DetailsNumber
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={isRequiredField}
                    fieldIsStatic={fieldIsStatic.includes(field)}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    max={400}
                    min={0}
                  />
                )
              } else {
                return ('')
              }
            } else if(fieldInfo.name === FieldNames.featureFields.isVegetationManual) {
              return (
                <DetailsCheckbox
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  allFields={FieldNames.featureFields}
                />
              )
            } else if (fieldInfo.name === FieldNames.featureFields.notes || fieldInfo.name === FieldNames.featureFields.contributedNotes) {
              return (
                <DetailsTextArea
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isRequiredField}
                  fieldIsStatic={fieldIsStatic.includes(field)}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  isActuals={false}
                />
              )
            } else if (fieldInfo.name === FieldNames.featureFields.statusReason) {
              let tempReqFields = requiredFields;
              if(!getAllApprovalFieldsCount()){
                if(treatment && treatment.attributes && requiredFields && requiredFields.length){
                  if(treatment.attributes[FieldNames.featureFields.status] !== FieldNames.statuses.cancelled){
                    tempReqFields = requiredFields.filter(field => field !== FieldNames.featureFields.statusReason);
                  }
                } else if(activity && requiredFields && requiredFields.length){
                  if(activity.attributes[FieldNames.featureFields.status] !== FieldNames.statuses.cancelled){
                    tempReqFields = requiredFields.filter(field => field !== FieldNames.featureFields.statusReason);
                  }
                }
              }
              let isTempReqFields = false;
              if(tempReqFields && tempReqFields.length){
                isTempReqFields = tempReqFields.includes(field);
              }
              return (
                <DetailsTextArea
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isTempReqFields}
                  fieldIsStatic={false}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  isActuals={false}
                />
              )
            } else if (fieldInfo.name === FieldNames.featureFields.unApprovalReason) {
              return (
                <DetailsTextArea
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={detail && detail.attributes && detail.attributes[FieldNames.featureFields.unApprovalDate] ? true : false}
                  fieldIsStatic={true}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  isActuals={false}
                />
              )
            }else if (
              fieldInfo.name === FieldNames.featureFields.cancelledDate) 
            {
              if(!detail?.attributes[FieldNames.featureFields.cancelledDate])
              {
                return (
                  <Button
                    variant='contained'
                    onClick={() => setCancelEditorOpen(true)}
                  >
                    Cancel
                  </Button>
                )
              }
              else
              {
                let finalValue = formatDateForDisplay(detail.attributes[FieldNames.featureFields.cancelledDate]);
                return finalValue;
              }
            }
            else if(fieldInfo.name === FieldNames.featureFields.obligationFiscalYear){
              return (
                <DetailsYearPicker
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isRequiredField}
                  allFields={FieldNames.featureFields}
                  isActuals={false}
                />
              )
            }else if (fieldInfo.name === FieldNames.featureFields.durability) {
              return (
                <DetailsNumber
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isRequiredField}
                  fieldIsStatic={fieldIsStatic.includes(field)}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                />
              )
            } else if (fieldInfo.name === FieldNames.featureFields.parentID) {
              if (detail && detail.attributes && detail.attributes[fieldInfo.name]) {
                return (
                  <Link onClick={() => parentRedirect(detail.attributes[fieldInfo.name], FieldNames.modes.read, FieldNames.featureFields)}><span className='pointer'>{detail.attributes[fieldInfo.name]}</span></Link>
                )
              } else {
                return (
                  <span>--</span>
                )
              }
            } else if(fieldInfo.name === FieldNames.featureFields.tribeName){
              if(detail && detail.attributes){
                const isEditable = isEditableAfterApproval(field, isNew);
                if(isEditable){
                  return (
                    <DetailsAutoComplete
                      userInfo={userInfo} 
                      field={field}
                      parentValue={null}
                      selectionValue={tribeNameValue}
                      setSelectionValue={setTribeNameValue}
                      userRoleInfo={userRoleInfo}
                      onFieldChange={onFieldChange}
                      detail={detail}
                      isRequired={isRequiredField}
                    />
                  )
                } else {
                  return (
                    <DetailsText
                      detail={detail}
                      field={field}
                      onFieldChange={onFieldChange}
                      isRequired={isRequiredField}
                      fieldIsStatic={true}
                      getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                      selectionValue={tribeNameValue}
                    />
                  )
                }
              }
            } else if(fieldInfo.name === FieldNames.featureFields.agency){
              if(detail && detail.attributes){
                const isEditable = isEditableAfterApproval(field, isNew) && !isFieldLockedDown(field, detail);
                if(isEditable){
                  return (
                    <DetailsAutoComplete
                      userInfo={userInfo}
                      field={field}
                      parentValue={null}
                      selectionValue={locationAgencyValue}
                      setSelectionValue={setLocationAgencyValue}
                      userRoleInfo={userRoleInfo}
                      onFieldChange={onFieldChange}
                      detail={detail}
                      isRequired={isRequiredField}
                    />
                  )
                } else {
                  return (
                    <DetailsText
                      detail={detail}
                      field={field}
                      onFieldChange={onFieldChange}
                      isRequired={isRequiredField}
                      fieldIsStatic={true}
                      getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                      selectionValue={tribeNameValue}
                    />
                  )
                }
              }
            } else if(fieldInfo.name === FieldNames.featureFields.region){
              if(detail && detail.attributes){
                const isEditable = isEditableAfterApproval(field, isNew) && !isFieldLockedDown(field, detail);
                if(isEditable){
                  return (
                    <DetailsAutoComplete 
                      userInfo={userInfo} 
                      field={field}
                      parentValue={null}
                      selectionValue={locationRegionValue}
                      setSelectionValue={setLocationRegionValue}
                      userRoleInfo={userRoleInfo}
                      onFieldChange={onFieldChange}
                      detail={detail}
                      isRequired={isRequiredField}
                    />
                  )
                } else {
                  return (
                    <DetailsText
                      detail={detail}
                      field={field}
                      onFieldChange={onFieldChange}
                      isRequired={isRequiredField}
                      fieldIsStatic={true}
                      getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                      selectionValue={tribeNameValue}
                    />
                  )
                }
              }
            } else if(fieldInfo.name === FieldNames.featureFields.unit){
              if(detail && detail.attributes){
                const isEditable = isEditableAfterApproval(field, isNew) && !isFieldLockedDown(field, detail);
                if(isEditable){
                  return (
                    <DetailsAutoComplete 
                      userInfo={userInfo} 
                      field={field}
                      parentValue={null}
                      selectionValue={locationUnitValue}
                      setSelectionValue={setLocationUnitValue}
                      userRoleInfo={userRoleInfo}
                      onFieldChange={onFieldChange}
                      detail={detail}
                      isRequired={isRequiredField}
                    />
                  )
                } else {
                  return (
                    <DetailsText
                      detail={detail}
                      field={field}
                      onFieldChange={onFieldChange}
                      isRequired={isRequiredField}
                      fieldIsStatic={true}
                      getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                      selectionValue={tribeNameValue}
                    />
                  )
                }
              }
            } else if(fieldInfo.name === FieldNames.featureFields.fundingSource || fieldInfo.name === FieldNames.featureFields.fundingUnitType || 
              fieldInfo.name === FieldNames.featureFields.fundingUnit || fieldInfo.name === FieldNames.featureFields.fundingRegion || 
              fieldInfo.name === FieldNames.featureFields.fundingAgency || fieldInfo.name === FieldNames.featureFields.fundingDepartment || 
              fieldInfo.name === FieldNames.featureFields.fundingSourceProgram || fieldInfo.name === FieldNames.featureFields.fundingSourceCategory ||
              fieldInfo.name === FieldNames.featureFields.fundingSourceSubCategory){   
              if(detail && detail.attributes){
                const tempVal = getFieldDisplayValue(detail.attributes[field], fieldInfo.name, FieldNames.featureFields);
                return (
                  <DetailsText
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={isRequiredField}
                    fieldIsStatic={false}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    selectionValue={tempVal}
                  />
                )
              }
            } else if(fieldInfo.name === FieldNames.featureFields.fundingSubUnit){
              if(detail.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.blm) && detail && detail.attributes){
                const tempVal = getFieldDisplayValue(detail.attributes[field], fieldInfo.name, FieldNames.featureFields);
                return (
                  <DetailsText
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={isRequiredField}
                    fieldIsStatic={false}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    selectionValue={tempVal}
                  />
                )
              } else {
                return <span></span>
              }
            } else if(fieldInfo.name === FieldNames.featureFields.fundingTribe){
              if(detail.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.bia) && detail && detail.attributes){
                const tempVal = getFieldDisplayValue(detail.attributes[field], fieldInfo.name, FieldNames.featureFields);
                return (
                  <DetailsText
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={isRequiredField}
                    fieldIsStatic={false}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    selectionValue={tempVal}
                  />
                )
              } else {
                return <span></span>
              }
            } else if (fieldInfo.name === FieldNames.featureFields.department) {
              if(detail && detail.attributes){
                return (
                  <DetailsSelect
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    fieldInfo={fieldInfo}
                    isRequired={isRequiredField}
                    allFields={FieldNames.featureFields}
                    fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, detail)}
                    classValue={classValue}
                    setClassValue={setClassValue}
                    categoryValue={categoryValue}
                    setCategoryValue={setCategoryValue}
                    unitOfMeasureValue={unitOfMeasureValue}
                    setUnitOfMeasureValue={setUnitOfMeasureValue}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    fundingSourceOptions={fundingSourceOptions}
                    departureOptions={departureIndexOptions}
                    statusOptions={statusOptions}
                    isActuals={false}
                    typeValue={typeValue}
                    setTypeValue={setTypeValue}
                    subTypeValue={subTypeValue}
                    setSubTypeValue={setSubTypeValue}
                    agencyValue={detail?.attributes?.[FieldNames.featureFields.fundingAgency]}
                    locationDepartmentValue={locationDepartmentValue}
                    setLocationDepartmentValue={setLocationDepartmentValue}
                    programValue={programValue}
                    setProgramValue={setProgramValue}
                  />
                )
              }
            } else if(fieldInfo.name === FieldNames.featureFields.contributedFundingSource) { 
              const fundOptions = contributedFundingSourceOptions;
              return (
                <DetailsSelect
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  fieldInfo={fieldInfo}
                  isRequired={isRequiredField}
                  allFields={FieldNames.featureFields}
                  fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, detail)}
                  classValue={classValue}
                  setClassValue={setClassValue}
                  categoryValue={categoryValue}
                  setCategoryValue={setCategoryValue}
                  unitOfMeasureValue={unitOfMeasureValue}
                  setUnitOfMeasureValue={setUnitOfMeasureValue}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  fundingSourceOptions={fundingSourceOptions}
                  departureOptions={departureIndexOptions}
                  statusOptions={statusOptions}
                  isActuals={false}
                  typeValue={typeValue}
                  setTypeValue={setTypeValue}
                  subTypeValue={subTypeValue}
                  setSubTypeValue={setSubTypeValue}
                  agencyValue={detail?.attributes?.[FieldNames.featureFields.fundingAgency]}
                  locationDepartmentValue={locationDepartmentValue}
                  setLocationDepartmentValue={setLocationDepartmentValue}
                  programValue={programValue}
                  setProgramValue={setProgramValue}
                />
              )
            } else if(fieldInfo.name === FieldNames.featureFields.type || fieldInfo.name === FieldNames.featureFields.category || 
              fieldInfo.name === FieldNames.featureFields.class || fieldInfo.name === FieldNames.featureFields.unitOfMeasure || 
              fieldInfo.name === FieldNames.featureFields.program) {
              let onlyAgencyRole = detail?.attributes[FieldNames.featureFields.fundingAgency];
              if(!onlyAgencyRole && userRoleInfo && userRoleInfo.length === 1){
                onlyAgencyRole = userRoleInfo[0][FieldNames.userRoles.agency];
              }
              const isPostFire = isFeaturePostFire(detail.attributes)
              if(detail && detail.attributes){
                if(fieldInfo.name !== FieldNames.featureFields.unitOfMeasure || (isPostFire && fieldInfo.name === FieldNames.featureFields.unitOfMeasure)){
                  return (
                    <DetailsSelect
                      detail={detail}
                      field={field}
                      onFieldChange={onFieldChange}
                      fieldInfo={fieldInfo}
                      isRequired={isRequiredField}
                      allFields={FieldNames.featureFields}
                      fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, detail)}
                      classValue={classValue}
                      setClassValue={setClassValue}
                      categoryValue={categoryValue}
                      setCategoryValue={setCategoryValue}
                      unitOfMeasureValue={unitOfMeasureValue}
                      setUnitOfMeasureValue={setUnitOfMeasureValue}
                      getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                      fundingSourceOptions={fundingSourceOptions}
                      departureOptions={departureIndexOptions}
                      statusOptions={statusOptions}
                      isActuals={false}
                      typeValue={typeValue}
                      setTypeValue={setTypeValue}
                      subTypeValue={subTypeValue}
                      setSubTypeValue={setSubTypeValue}
                      agencyValue={detail && detail.attributes && detail.attributes[FieldNames.featureFields.fundingAgency] ? detail.attributes[FieldNames.featureFields.fundingAgency] : onlyAgencyRole}
                      locationDepartmentValue={locationDepartmentValue}
                      setLocationDepartmentValue={setLocationDepartmentValue}
                      programValue={programValue}
                      setProgramValue={setProgramValue}
                    />
                  )
                } else {
                  return ('')
                }
              }
            } else if(fieldInfo.name === FieldNames.featureFields.subType) {
              let onlyAgencyRole = detail?.attributes[FieldNames.featureFields.fundingAgency];
              if(!onlyAgencyRole && userRoleInfo && userRoleInfo.length === 1){
                onlyAgencyRole = userRoleInfo[0][FieldNames.userRoles.agency];
              }
              const subTypePossibleValues = getByLevel(detail?.attributes, FieldNames.categoryAssociationFields.subTypes)
              if(detail?.attributes && subTypePossibleValues?.length > 0){
                return (
                  <DetailsSelect
                    detail={detail}
                    field={field}
                    onFieldChange={onFieldChange}
                    fieldInfo={fieldInfo}
                    isRequired={isRequiredField}
                    allFields={FieldNames.featureFields}
                    fieldIsStatic={fieldIsStatic?.includes(field) || isFieldLockedDown(field, detail)}
                    classValue={classValue}
                    setClassValue={setClassValue}
                    categoryValue={categoryValue}
                    setCategoryValue={setCategoryValue}
                    unitOfMeasureValue={unitOfMeasureValue}
                    setUnitOfMeasureValue={setUnitOfMeasureValue}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    fundingSourceOptions={fundingSourceOptions}
                    departureOptions={departureIndexOptions}
                    statusOptions={statusOptions}
                    isActuals={false}
                    typeValue={typeValue}
                    setTypeValue={setTypeValue}
                    subTypeValue={subTypeValue}
                    setSubTypeValue={setSubTypeValue}
                    agencyValue={detail?.attributes?.[FieldNames.featureFields.fundingAgency] ? detail.attributes[FieldNames.featureFields.fundingAgency] : onlyAgencyRole}
                    locationDepartmentValue={locationDepartmentValue}
                    setLocationDepartmentValue={setLocationDepartmentValue}
                    programValue={programValue}
                    setProgramValue={setProgramValue}
                  />
                )
              } else {
                return <span></span>
              }
            } else if(fieldInfo.name === FieldNames.featureFields.status) {
              return (
                <DetailsSelect
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  fieldInfo={fieldInfo}
                  isRequired={isRequiredField}
                  allFields={FieldNames.featureFields}
                  fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, detail)}
                  classValue={classValue}
                  setClassValue={setClassValue}
                  categoryValue={categoryValue}
                  setCategoryValue={setCategoryValue}
                  unitOfMeasureValue={unitOfMeasureValue}
                  setUnitOfMeasureValue={setUnitOfMeasureValue}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  fundingSourceOptions={fundingSourceOptions}
                  departureOptions={departureIndexOptions}
                  statusOptions={statusOptions}
                  isActuals={false}
                  typeValue={typeValue}
                  setTypeValue={setTypeValue}
                  subTypeValue={subTypeValue}
                  setSubTypeValue={setSubTypeValue}
                  agencyValue={detail?.attributes?.[FieldNames.featureFields.fundingAgency]}
                  locationDepartmentValue={locationDepartmentValue}
                  setLocationDepartmentValue={setLocationDepartmentValue}
                  programValue={programValue}
                  setProgramValue={setProgramValue}
                />
              )
            } else if(fieldInfo.name === FieldNames.featureFields.projectName) {
              return (
                <DetailsAutoComplete
                  userInfo={userInfo} 
                  field={field}
                  parentValue={null}
                  selectionValue={projectValue}
                  setSelectionValue={setProjectValue}
                  userRoleInfo={userRoleInfo}
                  onFieldChange={onFieldChange}
                  detail={detail}
                  isRequired={isRequiredField}
                />
              )
            } else if(fieldInfo.name === FieldNames.featureFields.projectNotes) {
              return (
                <DetailsTextArea
                  detail={detail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={isRequiredField}
                  fieldIsStatic={true}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  isActuals={false}
                />
              )
            } else {
              if (fieldInfo.domain) {
                if((field === FieldNames.featureFields.treatmentDriver && detail?.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.blm)) || field !== FieldNames.featureFields.treatmentDriver){
                  return (
                    <DetailsSelect
                      detail={detail}
                      field={field}
                      onFieldChange={onFieldChange}
                      fieldInfo={fieldInfo}
                      isRequired={isRequiredField}
                      allFields={FieldNames.featureFields}
                      fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, detail)}
                      classValue={classValue}
                      setClassValue={setClassValue}
                      categoryValue={categoryValue}
                      setCategoryValue={setCategoryValue}
                      unitOfMeasureValue={unitOfMeasureValue}
                      setUnitOfMeasureValue={setUnitOfMeasureValue}
                      getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                      fundingSourceOptions={fundingSourceOptions}
                      departureOptions={departureIndexOptions}
                      statusOptions={statusOptions}
                      isActuals={false}
                      typeValue={typeValue}
                      setTypeValue={setTypeValue}
                      subTypeValue={subTypeValue}
                      setSubTypeValue={setSubTypeValue}
                      agencyValue={detail?.attributes?.[FieldNames.featureFields.fundingAgency]}
                      locationDepartmentValue={locationDepartmentValue}
                      setLocationDepartmentValue={setLocationDepartmentValue}
                      programValue={programValue}
                      setProgramValue={setProgramValue}
                    />
                  )
                } else {
                  return <span></span>
                }
              } //Do not put an else here or some fields won't drop down to the Details Text below - ie WBSID
            }
          }
        }
      }
      return (
        <DetailsText
          detail={detail}
          field={field}
          onFieldChange={onFieldChange}
          isRequired={isRequiredField}
          fieldIsStatic={fieldIsStatic.includes(field)}
          getAllApprovalFieldsCount={getAllApprovalFieldsCount}
        />
      )
    } else {
      return ('')
    }
  }

  const formLabel = () => {
    if(detail?.attributes && field === FieldNames.featureFields.statusReason && detail?.attributes[FieldNames.featureFields.status] !== FieldNames.statuses.cancelled){
      return (<span></span>)
    } else if(detail && detail.attributes && field === FieldNames.featureFields.unapprovalDate && !detail.attributes[FieldNames.featureFields.unApprovalDate]){
      return (<span></span>)
    } else if(field === FieldNames.featureFields.fundingTribe){
      return (<span></span>)
    } else if(field === FieldNames.featureFields.wbsID){
      if(detail?.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.blm)){
        return (<span className="required">*</span>)
      } else {
        return (<span></span>)
      }
    } else if(field === FieldNames.featureFields.isSagebrush){
      if(detail?.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.blm)){
        return (<span className="required">*</span>)
      } else {
        return (<span></span>)
      }
    } else if(field === FieldNames.featureFields.treatmentDriver){
      if(detail?.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.blm)){
        return (<span className="required">*</span>)
      } else {
        return (<span></span>)
      }
    } else {
      if(requiredFields && requiredFields.length && requiredFields.includes(field)) {
        return (<span className="required">*</span>)
      } else {
        return (<span></span>)
      }
    }
    
  }

  const getLabel = (isTreatment) => {
    const isPostFire = isFeaturePostFire(detail?.attributes);
    if(currentfieldInfo){
      if(field === FieldNames.featureFields.id){
        return isTreatment ? FieldNames.legacyIDFields.treatmentIDSpaced : FieldNames.legacyIDFields.activityIDSpaced;
      } else if(field === FieldNames.featureFields.wbsID){
        return "WBS";
      } else if(field === FieldNames.featureFields.vegDeparturePercentageManual) {
        return "Vegetation Departure Percentage";
      } else if(field === FieldNames.featureFields.isVegetationManual){
        return "Is Vegetation Departure Manual";
      } else if(field === FieldNames.featureFields.estimatedAssetCost){
        return "Total Asset Cost";
      } else if(field === FieldNames.featureFields.estimatedContractualCost){
        return "Total Contractual Cost";
      } else if(field === FieldNames.featureFields.estimatedGrantsFixedCost){
        return "Total Grants Fixed Cost";
      } else if(field === FieldNames.featureFields.estimatedOtherCost){
        return "Total Other Cost";
      } else if(field === FieldNames.featureFields.estimatedPersonnelCost){
        return "Total Personnel Cost";
      } else if(field === FieldNames.featureFields.estimatedTotalCost){
        return "Total Cost";
      } else if(field === FieldNames.featureFields.fundingTribe) {
        if(detail?.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.bia)){
          return `${currentfieldInfo.alias}`
        } else {
          return ``;
        }

      } else if(field === FieldNames.featureFields.fundingSubUnit || field === FieldNames.featureFields.treatmentDriver) {
        if(detail?.attributes[FieldNames.featureFields.fundingAgency]?.includes(FieldNames.agencies.blm)){
          return `${currentfieldInfo.alias}`
        } else {
          return ``;
        }

      } else if(field === FieldNames.featureFields.subType){
        const subTypePossibleValues = getByLevel(detail?.attributes, FieldNames.categoryAssociationFields.subTypes)
        if(subTypePossibleValues?.length > 0){
          return `${currentfieldInfo.alias}`
        } else {
          return ``;
        }
      } else if(field === FieldNames.featureFields.measureAmount || field === FieldNames.featureFields.unitOfMeasure){
        if(isPostFire){
          return `${currentfieldInfo.alias}`
        } else {
          return
        }
      } else if(field === FieldNames.featureFields.isInteragency){ 
        if(!isPostFire){
          return `${currentfieldInfo.alias}`
        } else {
          return
        }
      } else if(field === FieldNames.featureFields.interagencySupport){ 
        if(!isPostFire && detail?.attributes[FieldNames.featureFields.isInteragency] === FieldNames.yesNo.yes){
          return `${currentfieldInfo.alias}`
        } else {
          return
        }
      } else {
        return `${currentfieldInfo.alias}`
      }
    } else if(field === FieldNames.featureFields.unApprovalButton){
      if(detail && detail.attributes){
      //Not a database field so no field info for it
        if(mode === FieldNames.modes.edit && !detail.attributes[FieldNames.featureFields.unApprovalDate]){
          return (
            <Button 
              color="primary" 
              variant="contained" 
              disabled={
                detail && detail.attributes && !detail.attributes[FieldNames.featureFields.departmentApprovalDate] && !detail.attributes[FieldNames.featureFields.agencyApprovalDate] &&
                !detail.attributes[FieldNames.featureFields.regionalApprovalDate] && !detail.attributes[FieldNames.featureFields.localApprovalDate]
              } 
              onClick={() => addUnApprovalDate()}
            >
              Request UnApproval
            </Button>
          )
        } else if(mode === FieldNames.modes.edit && detail.attributes[FieldNames.featureFields.unApprovalDate]){
          return (
            <Button 
              color="primary" 
              variant="contained" 
              disabled={
                detail && detail.attributes && !detail.attributes[FieldNames.featureFields.departmentApprovalDate] && !detail.attributes[FieldNames.featureFields.agencyApprovalDate] &&
                !detail.attributes[FieldNames.featureFields.regionalApprovalDate] && !detail.attributes[FieldNames.featureFields.localApprovalDate]
              } 
              onClick={() => clearUnApprovalDate()}
            >
              Clear UnApproval
            </Button>
          )
        } else {
          return('')
        }
      } else {
        return ('')
      }
    } else {
      return `**${field}`
    }
  }

  return (
    <Fragment>
      {( ((field === FieldNames.featureFields.priority || field === FieldNames.featureFields.feasibility) && categoryValue !== FieldNames.categoriesForChecking.programManagement) || (field !== FieldNames.featureFields.priority && field !== FieldNames.featureFields.feasibility) ) &&
      <Grid item size={12} container direction="row"
        className="grid-item" style={{ alignItems: 'center', minWidth: '550px', paddingRight: '5px' }}>
        <Grid item size={6} style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word'}}>
          <span>
            <label>{getLabel(isTreatment)}{formLabel()}</label>
            <DetailsPopover mode={mode} field={field} isTreatment={isTreatment} categoryValue={categoryValue} isPoint={ (detail && detail.attributes) ? detail.attributes[FieldNames.featureFields.isPoint] : FieldNames.yesNo.no } isActuals={false} agencyValue={detail?.attributes[FieldNames.featureFields.fundingAgency]} isBulkApproval={false} />
          </span>
        </Grid>
        <Grid item size={6} style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word'}}>
          {(mode === FieldNames.modes.read) ? ((detail && detail.attributes) ? getReadOnlyString(field) : '--') : (field === FieldNames.featureFields.unApprovalButton ? getEditControlForField(field) : getEditControlForField(currentfieldInfo))}
        </Grid>
      </Grid>
      }
    </Fragment>
  )
}
